import React from 'react';
import { useIntl } from 'react-intl';
import {
  Container,
  Center,
  ErrorCircle,
  Title,
  Paragraph,
  Card,
  CardBody,
  NextStepsTitle,
  Steps,
  StepItem,
} from './styles';
import { CheckErrorIcon } from '../../../components/Icons';

function VerificationFailed() {
  const intl = useIntl();

  return (
    <Container>
      <Center>
        {/* Error Icon */}
        <ErrorCircle>
          <CheckErrorIcon />
        </ErrorCircle>

        {/* Error Message */}
        <div style={{ marginBottom: '2rem' }}>
          <Title>{intl.messages['verificationFailed.title']}</Title>
          <Paragraph>
            {intl.messages['verificationFailed.terminated']} <b>{intl.messages['verificationFailed.terminated.bold']}</b>{' '}
          </Paragraph>
        </div>

        {/* Instructions Card */}
        <Card>
          <CardBody>
            <NextStepsTitle>
              {intl.messages['verificationFailed.nextSteps.title']}
            </NextStepsTitle>
            <Steps>
              <StepItem>
                {intl.messages['verificationFailed.nextSteps.step1']}{' '}
                <b>{intl.messages['verificationFailed.nextSteps.step1.1']}</b>{' '}
                {intl.messages['verificationFailed.nextSteps.step1.2']}
              </StepItem>
              <StepItem>
                {intl.messages['verificationFailed.nextSteps.step2']}
              </StepItem>
              <StepItem>
                {intl.messages['verificationFailed.nextSteps.step3']}
              </StepItem>
            </Steps>
          </CardBody>
        </Card>
      </Center>
    </Container>
  );
}

export default VerificationFailed;
